import { faBolt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Box, Button, Group, Stack, Text } from '@mantine/core'
import { COLORS } from '../../utils/constants'

interface AllLocationsCtaBannerProps {
  onBookAllLocations: () => void
}

export function AllLocationsCtaBanner({
  onBookAllLocations,
}: AllLocationsCtaBannerProps) {
  return (
    <Box
      px={24}
      py={22}
      mb={20}
      style={{
        background: '#b8d4c8',
        borderRadius: 12,
      }}
    >
<Group justify='space-between' align='center' wrap='wrap' gap='lg'>
        <Stack gap={10}>
          {/* Eye-catching badge row */}
          <Group gap={8}>
            <Badge
              size='md'
              radius='sm'
              style={{
                background: 'white',
                color: COLORS.DarkGreen,
                border: 'none',
                letterSpacing: '0.06em',
                fontWeight: 700,
              }}
              leftSection={
                <FontAwesomeIcon icon={faBolt} style={{ fontSize: 10, color: COLORS.HiddenGemzGold }} />
              }
            >
              Best Reach
            </Badge>
          </Group>

          <Text size='xl' fw={800} c={COLORS.DarkGreen} lh={1.2}>
            Advertise at Every Location
          </Text>
          <Text size='sm' style={{ color: 'rgba(3,55,35,0.65)' }}>
            One ad, every screen in the network — configure once, run everywhere
          </Text>
        </Stack>

        <Button
          size='md'
          radius='md'
          onClick={onBookAllLocations}
          style={{
            flexShrink: 0,
            background: COLORS.HiddenGemzRed,
            color: 'white',
            boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
            fontWeight: 700,
          }}
        >
          Book All Locations
        </Button>
      </Group>
    </Box>
  )
}
